<template>
  <div>
    <CModal
      :show.sync="disable"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Modal title 2"
      color="dark"
    >
      <template #header>
        <h6 class="modal-title">{{onCheck(fields.evaluationPlan)}}</h6>
        <CButtonClose @click="onUpdatePlan" class="text-white"/>
      </template>
      <template #body-wrapper>
        <div class="p-2">
<!--          {{this.onCheck(this.fields.lessonPlans)}}-->
          <CRow>
            <CCol col="12">
              <CButton class="w-100 mb-2" @click="onUpdatePlan" color="danger">{{onCheck(fields.cancel)}}</CButton>
            </CCol>
            <CCol col="12">
              <CButton class="w-100 mb-2" @click="onUpdatePlan" color="danger">{{onCheck(fields.cancel)}}</CButton>
            </CCol>
            <CCol col="12">
              <CButton class="w-100 " @click="onUpdatePlan" color="danger">{{onCheck(fields.cancel)}}</CButton>
            </CCol>
          </CRow>
        </div>
      </template>
      <template #footer>
        <CButton @click="onUpdatePlan" color="danger">{{onCheck(fields.cancel)}}</CButton>
        <CButton @click="onUpdatePlanSubmit" color="success">{{onCheck(fields.save)}}</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Vue from 'vue'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor)

// import QuillBetterTable from 'quill-better-table'
// Quill.register({
//   'modules/better-table': QuillBetterTable
// }, true)
export default {
  name: 'DialogConsistency',
  props: {
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      lang: "th",
      darkModal: true,
      fields: {

        evaluationPlan: [
          {
            key: "th",
            value: "การพัฒนาผลการเรียนรู้ของนักศึกษา"
          },
          {
            key: "en",
            value: "Lesson Plan and Evaluation"
          }
        ],
        evaluationPlans: [
          {
            key: "th",
            value: [
              {key: 'skills', label: 'แผนการ'},
              {key: 'week', label: 'วิธีการสอน'},
              {key: 'method', label: 'วิธีการประเมิน'},
              {key: '#', label: "#", _style: 'width:2%; text-align: center'}
            ]
          }, {
            key: "en",
            value: [
              {key: 'skills', label: 'plan'},
              {key: 'week', label: 'Assessment Week'},
              {key: 'method', label: 'Assessment Method'},
              {key: '#', label: "#", _style: 'width:2%; text-align: center'}
            ]
          }
        ],
        save: [
          {
            key: "th",
            value: "บันทึก"
          },
          {
            key: "en",
            value: "Save"
          }
        ],
        cancel: [
          {
            key: "th",
            value: "ยกเลิก"
          },
          {
            key: "en",
            value: "Cancel"
          }
        ]
      },
      data: {
        reason:''
      }
    }
  },
  mounted() {

  },

  created() {
    // this.content = this.onCheck(this.values.fields)
  },

  beforeDestroy() {

  },

  methods: {

    onCheck(key) {
      for (var i = 0; i < key.length; i++) {
        if (key[i].key == this.lang) {
          return key[i].value;
        } else {
          if (key[i].key == "ch") {
            return key[i].value;
          }
        }
      }
    },


    onChane(html, text, quill) {
      console.log(html)
    },

    onUpdatePlan(){
      this.$store.dispatch("dialogCreate/setDialogConsistency",false)
    },

    onUpdatePlanSubmit(){
      this.$store.dispatch("dialogCreate/setDialogConsistency",false)
    },
  },


  computed: {
    ...mapGetters({
      stateDialog : "dialogCreate/onGetDialogConsistency",
    })
  },

  watch: {
  }
}
</script>
